import { merge } from 'lodash'
import { colors } from 'styles/colors'

interface SpeechBubbleStyleProps {
  color?: string
  parentColor?: string
  bubbleColor?: string
  direction?: 'left' | 'right'
}

const useSpeechBubbleStyles = ({
  color = colors.common.black,
  parentColor = colors.common.white,
  bubbleColor = colors.grey[300],
  direction = 'left',
}: SpeechBubbleStyleProps) => {
  const arrow =
    direction === 'left'
      ? {
          alignSelf: 'flex-end',
          color,
          backgroundColor: bubbleColor,

          '&:before': {
            right: '-7px',
            backgroundColor: bubbleColor,
            borderBottomLeftRadius: '16px 14px',
          },

          '&:after': {
            right: '-26px',
            borderBottomLeftRadius: '10px',
          },
        }
      : {
          alignSelf: 'flex-start',
          color,
          backgroundColor: bubbleColor,

          '&:before': {
            left: '-7px',
            backgroundColor: bubbleColor,
            borderBottomRightRadius: '16px 14px',
          },

          '&:after': {
            left: '-26px',
            borderBottomRightRadius: '10px',
          },
        }

  const defaultStyles = {
    position: 'relative',
    maxWidth: '255px',
    marginBottom: '16px',
    padding: '16px 18px 10px',
    lineHeight: '24px',
    wordWrap: 'break-word',
    borderRadius: '25px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',

    '&:before': {
      width: '20px',
    },

    '&:after': {
      width: '26px',
      backgroundColor: parentColor,
    },

    '&:before, &:after': {
      position: 'absolute',
      bottom: 0,
      height: '25px',
      transition: 'transform 200ms ease-out',
      content: '""',
    },
  }

  return merge(arrow, defaultStyles)
}

export default useSpeechBubbleStyles
